export const BOOKING_STATUS = {
  CANCELLED: "cancelled",
  CHECKED_IN: "checked_in",
  PART_CHECKED_IN: "part_checked_in",
  CHECKED_OUT: "checked_out",
  PART_CHECKED_OUT: "part_checked_out",
  RESERVED: "reserved",
  CONFIRMED: "confirmed",
  ON_HOLD: "reserved",
  NO_SHOW: "noshow",
} as const;

export const GUEST_STATUS = {
  CANCELLED: "cancelled",
  ACTIVE: "active",
  CHECKED_IN: "checked_in",
  CHECKED_OUT: "checked_out",
  RESERVED: "reserved",
  NO_SHOW: "noshow",
} as const;

export const GUEST_AGE_GROUP = {
  ADULT: "adult",
  CHILD: "child",
} as const;

export const ROOM_STATUS = {
  CANCELLED: "cancelled",
  ACTIVE: "active",
  NO_SHOW: "noshow",
  CHECKED_IN: "checked_in",
  PART_CHECKED_IN: "part_checked_in",
  CHECKED_OUT: "checked_out",
  PART_CHECKED_OUT: "part_checked_out",
} as const;

export const BILLED_ENTITY_CATEGORY = {
  TRAVEL_AGENT: "travel_agent",
  BOOKER_COMPANY: "booker_company",
  BOOKER: "booker",
  PRIMARY_GUEST: "primary_guest",
} as const;

export type BilledEntityCategoryType =
  (typeof BILLED_ENTITY_CATEGORY)[keyof typeof BILLED_ENTITY_CATEGORY];

export type BookingStatusType =
  (typeof BOOKING_STATUS)[keyof typeof BOOKING_STATUS];
export type GuestStatusType = (typeof GUEST_STATUS)[keyof typeof GUEST_STATUS];
export type RoomStatusType = (typeof ROOM_STATUS)[keyof typeof ROOM_STATUS];

export const EXCLUDED_ROOM_STATUSES = [
  ROOM_STATUS.CANCELLED,
  ROOM_STATUS.NO_SHOW,
] as const;

export const IN_STAY_ROOM_STATUSES = new Set<string>([
  ROOM_STATUS.CHECKED_IN,
  ROOM_STATUS.PART_CHECKED_IN,
  ROOM_STATUS.PART_CHECKED_OUT,
]);

export const isInStayRoomStatus = (status?: string | null): boolean =>
  !!status && IN_STAY_ROOM_STATUSES.has(status);

export const EXCLUDED_GUEST_STATUSES = [
  GUEST_STATUS.CANCELLED,
  GUEST_STATUS.NO_SHOW,
] as const;

export const isExcludedRoomStatus = (status: string | undefined): boolean =>
  status
    ? (EXCLUDED_ROOM_STATUSES as readonly string[]).includes(status)
    : false;

export const isExcludedGuestStatus = (status: string | undefined): boolean =>
  status
    ? (EXCLUDED_GUEST_STATUSES as readonly string[]).includes(status)
    : false;
